import { isNavigatingToMessageSignal, navigationOverlayTextSignal } from '../../state/ui.store';
import { Loader2, MessageSquare } from 'lucide-preact';

export function NavigationOverlay() {
  const isNavigating = isNavigatingToMessageSignal.value;
  const overlayText = navigationOverlayTextSignal.value;

  if (!isNavigating) return null;

  return (
    <div class="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-950/90 backdrop-blur-lg animate-fade-in select-none">
      <div class="p-6 bg-slate-900/95 border border-cyan-500/40 rounded-3xl shadow-2xl shadow-cyan-500/20 max-w-sm w-full text-center space-y-4 flex flex-col items-center">
        <div class="w-14 h-14 rounded-2xl bg-cyan-500/10 border border-cyan-500/30 flex items-center justify-center text-cyan-400 relative">
          <MessageSquare class="w-7 h-7 text-cyan-400" />
          <div class="absolute -bottom-1 -right-1 p-1 bg-slate-900 rounded-full border border-cyan-500/40">
            <Loader2 class="w-4 h-4 text-cyan-300 animate-spin" />
          </div>
        </div>

        <div class="space-y-1.5">
          <h3 class="text-sm font-extrabold text-slate-100">
            Navegando no Chat
          </h3>
          <p class="text-xs text-cyan-200/90 font-medium leading-relaxed">
            {overlayText}
          </p>
        </div>

        <div class="w-full bg-slate-800 rounded-full h-1.5 overflow-hidden border border-cyan-500/20">
          <div class="bg-gradient-to-r from-cyan-500 to-blue-500 h-full w-full animate-pulse" />
        </div>
      </div>
    </div>
  );
}
